var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-scrollbar",style:(_vm.style),on:{"scroll":_vm.onScroll}},[_c('div',{staticClass:"fm-scrollbar-wrap",style:(_vm.wrapStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }